<footer class="footer">
  <div class="reset" *ngIf="changesWereDone" (click)="resetChangesClicked()">
    <img src="assets/images/common/reset.svg" class="reset-icon" />
    <div class="reset-text">{{ 'common.reset' | labelsProvider }}</div>
  </div>
  <button class="cancel" (click)="cancelSettingsClicked()">
    {{ 'common.cancel' | labelsProvider }}
  </button>
  <button
    class="confirm"
    [ngClass]="{ 'confirm-disabled': !changesWereDone }"
    type="submit"
    (click)="saveChangesClicked()"
  >
    {{ 'common.save' | labelsProvider }}
  </button>
</footer>
